// extracted by mini-css-extract-plugin
export var redoItem = "_lf-1";
export var redoTrigger = "_lf-0";